/**
 * Detects whether the current page is being rendered inside the Femcare
 * **iOS app's WebView**. We use this to hide Android / Google Play content
 * from in-app views so the Apple App Store reviewer doesn't see references
 * to a competing platform inside the app itself.
 *
 * Two signals — either is enough:
 *
 *   1. Query string flag the iOS app appends when opening a help/legal page:
 *        https://femcare.life/support?platform=ios
 *        https://femcare.life/privacy?platform=ios
 *      (Recommended — explicit, no UA sniffing required.)
 *
 *   2. iOS WKWebView heuristic — iOS user-agent that does NOT contain
 *      "Safari". iOS Safari always includes "Safari" in its UA; an
 *      in-app WKWebView does not unless the app explicitly opts in.
 *      This is a safe fallback.
 *
 * Regular web visitors on iOS Safari, Android Chrome, or desktop browsers
 * will see all content as normal.
 */
export function isIOSAppWebView() {
    if (typeof window === "undefined") return false;

    const params = new URLSearchParams(window.location.search);
    const flag = (params.get("platform") || params.get("app") || "").toLowerCase();
    if (flag === "ios") return true;

    const ua = navigator.userAgent || "";
    const isIOS = /iPhone|iPad|iPod/i.test(ua);
    const isSafari = /Safari/i.test(ua) && !/CriOS|FxiOS|EdgiOS/i.test(ua);
    // iOS device + not Safari → WKWebView inside an app
    return isIOS && !isSafari;
}
